import request from '@/utils/request'

export function getGroupTourList(data) {
  return request({
    url: '/TravelSettings/getGroupTourList',
    method: 'post',
    data,
  })
}

export function getCommonTravelFormList(data) {
  return request({
    url: '/TravelSettings/getCommonTravelFormList',
    method: 'post',
    data,
  })
}

export function getGroupTourGuideRecordList(data) {
  return request({
    url: '/TravelSettings/getGroupTourGuideRecordList',
    method: 'post',
    data,
  })
}

export function getTravelTreavelersList(query) {
  return request({
    url: '/TravelSettings/getTravelTreavelersList',
    method: 'get',
    params: query,
  })
}

export function getTravelSeat(query) {
  return request({
    url: '/TravelSettings/getTravelSeat',
    method: 'get',
    params: query,
  })
}

export function getCommonForms(query) {
  return request({
    url: '/TravelSettings/getCommonForms',
    method: 'get',
    params: query,
  })
}

export function saveCommonForms(data) {
  return request({
    url: '/TravelSettings/saveCommonForms',
    method: 'post',
    data,
  })
}

// export function getLangOption(query) {
//   return request({
//     url: '/TravelSettings/getLangOption',
//     method: 'get',
//     params: query
//   })
// }

// export function getAnGroupTour(query) {
//   return request({
//     url: '/TravelSettings/getAnGroupTour',
//     method: 'get',
//     params: query
//   })
// }

export function saveTravelSeat(data) {
  return request({
    url: '/TravelSettings/saveTravelSeat',
    method: 'post',
    data,
  })
}

export function resetTravelSeat(data) {
  return request({
    url: '/TravelSettings/resetTravelSeat',
    method: 'post',
    data,
  })
}

export function saveGroupTour(data) {
  return request({
    url: '/TravelSettings/saveGroupTour',
    method: 'post',
    data,
  })
}

export function importTravelers(data) {
  return request({
    url: '/TravelSettings/importTravelers',
    method: 'post',
    data,
  })
}

// importTravelers v2
export function parseTravelersExcel(data) {
  return request({
    url: '/TravelSettings/parseTravelersExcel',
    method: 'post',
    data,
  })
}

export function uploadTravelers(data) {
  return request({
    url: '/TravelSettings/uploadTravelers',
    method: 'post',
    data,
  })
}

export function saveGroupTourCommonForms(data) {
  return request({
    url: '/TravelSettings/saveGroupTourCommonForms',
    method: 'post',
    data,
  })
}

export function getAgencyOptions(query) {
  return request({
    url: '/TravelSettings/getAgencyOptions',
    method: 'get',
    params: query,
  })
}

export function getTourLeaders(query) {
  return request({
    url: '/TravelSettings/getTourLeaders',
    method: 'get',
    params: query,
  })
}

export function setTourLeader(data) {
  return request({
    url: '/TravelSettings/setTourLeader',
    method: 'post',
    data,
  })
}

export function getTravelers(query) {
  return request({
    url: '/TravelSettings/getTravelers',
    method: 'get',
    params: query,
  })
}
export function setTravelers(data) {
  return request({
    url: '/TravelSettings/setTravelers',
    method: 'post',
    data,
  })
}
export function deleteTravelers(data) {
  return request({
    url: '/TravelSettings/deleteTravelers',
    method: 'post',
    data,
  })
}

export function removeTravelers(data) {
  return request({
    url: '/TravelSettings/removeTravelers',
    method: 'post',
    data,
  })
}

export function getItineraryPlanningSetting(query) {
  return request({
    url: '/TravelSettings/getItineraryPlanningSetting',
    method: 'get',
    params: query,
  })
}

export function getCountryRegions(query) {
  return request({
    url: '/TravelSettings/getCountryRegions',
    method: 'get',
    params: query,
  })
}

export function getCountriesByRegion(query) {
  return request({
    url: '/TravelSettings/getCountriesByRegion',
    method: 'get',
    params: query,
  })
}

export function getCitiesByCountryCode(query) {
  return request({
    url: '/TravelSettings/getCitiesByCountryCode',
    method: 'get',
    params: query,
  })
}

export function saveItineraryPlanningSetting(data) {
  return request({
    url: '/TravelSettings/saveItineraryPlanningSetting',
    method: 'post',
    data,
  })
}

export function saveItineraryPlanningSettingPassPorint(data) {
  return request({
    url: '/TravelSettings/saveItineraryPlanningSettingPassPorint',
    method: 'post',
    data,
  })
}

export function getItineraryPlanningSettingPassPorint(query) {
  return request({
    url: '/TravelSettings/getItineraryPlanningSettingPassPorint',
    method: 'get',
    params: query,
  })
}
export function getTravelCoupons(query) {
  return request({
    url: '/TravelSettings/getTravelCoupons',
    method: 'get',
    params: query,
  })
}
export function getCouponsWithTravelOutside(query) {
  return request({
    url: '/TravelSettings/getCouponsWithTravelOutside',
    method: 'get',
    params: query,
  })
}

export function saveTravelCouponMapping(data) {
  return request({
    url: '/TravelSettings/saveTravelCouponMapping',
    method: 'post',
    data,
  })
}

export function switchTravelCouponShowToSurvey(data) {
  return request({
    url: '/TravelSettings/switchTravelCouponShowToSurvey',
    method: 'post',
    data,
  })
}

export function deleteTravelCoupon(data) {
  return request({
    url: '/TravelSettings/deleteTravelCoupon',
    method: 'post',
    data,
  })
}

export function getPublicAlbum(query) {
  return request({
    url: '/TravelSettings/getPublicAlbum',
    method: 'get',
    params: query,
  })
}
export function getPublicAlbumAnPhoto(query) {
  return request({
    url: '/TravelSettings/getPublicAlbumAnPhoto',
    method: 'get',
    params: query,
  })
}

export function confirmTravelsOpinionSurveyByOpinionSurveyID(query) {
  return request({
    url: '/TravelSettings/confirmTravelsOpinionSurveyByOpinionSurveyID',
    method: 'get',
    params: query,
  })
}

export function getTravelsOpinionSurveyReplyDetails(data) {
  return request({
    url: '/TravelSettings/getTravelsOpinionSurveyReplyDetails',
    method: 'post',
    data,
  })
}

export function getTravelsOpinionSurveyReplyAllDetails(query) {
  return request({
    url: '/TravelSettings/getTravelsOpinionSurveyReplyAllDetails',
    method: 'get',
    params: query,
  })
}

export function getTravelsOpinionSurveyTopic(query) {
  return request({
    url: '/TravelSettings/getTravelsOpinionSurveyTopic',
    method: 'get',
    params: query,
  })
}

export function saveTravelsOpinionSurveySetting(data) {
  return request({
    url: '/TravelSettings/saveTravelsOpinionSurveySetting',
    method: 'post',
    data,
  })
}

export function getCarryItemsSetting(query) {
  return request({
    url: '/TravelSettings/getCarryItemsSetting',
    method: 'get',
    params: query,
  })
}

export function settingCarryItems(data) {
  return request({
    url: '/TravelSettings/settingCarryItems',
    method: 'post',
    data,
  })
}

export function getTravelAttractionsCascaderMenu(query) {
  return request({
    url: '/TravelSettings/getTravelAttractionsCascaderMenu',
    method: 'get',
    params: query,
  })
}

export function saveTravelNetworkSetting(data) {
  return request({
    url: '/TravelSettings/saveTravelNetworkSetting',
    method: 'post',
    data,
  })
}

export function getAgencyCouponsOption(query) {
  return request({
    url: '/TravelSettings/getAgencyCouponsOption',
    method: 'get',
    params: query,
  })
}

export function getTravelsOpinionSurveyPdfBeforeCheck(query) {
  return request({
    url: '/TravelSettings/getTravelsOpinionSurveyPdfBeforeCheck',
    method: 'get',
    params: query,
  })
}

export function getTravelAppAllowLoginDays(query) {
  return request({
    url: '/TravelSettings/getTravelAppAllowLoginDays',
    method: 'get',
    params: query,
  })
}

export function setTravelAppAllowLoginDays(data) {
  return request({
    url: '/TravelSettings/setTravelAppAllowLoginDays',
    method: 'post',
    data,
  })
}

export function getNetworkCardList(data) {
  return request({
    url: '/TravelSettings/getNetworkCardList',
    method: 'post',
    data,
  })
}

export function deleteNetworkCard(data) {
  return request({
    url: '/TravelSettings/deleteNetworkCard',
    method: 'post',
    data,
  })
}

export function saveNetworkCard(data) {
  return request({
    url: '/TravelSettings/saveNetworkCard',
    method: 'post',
    data,
  })
}

export function getCurrencyOptions(query) {
  return request({
    url: '/TravelSettings/getCurrencyOptions',
    method: 'get',
    params: query,
  })
}

export function getNetworkCardOptions(data) {
  return request({
    url: '/TravelSettings/getNetworkCardOptions',
    method: 'post',
    data,
  })
}

export function getTravelNetworkSetting(query) {
  return request({
    url: '/TravelSettings/getTravelNetworkSetting',
    method: 'get',
    params: query,
  })
}

export function getViewPoints(data) {
  return request({
    url: '/TravelSettings/getViewPoints',
    method: 'post',
    data,
  })
}

export function saveViewPoint(data) {
  return request({
    url: '/TravelSettings/saveViewPoint',
    method: 'post',
    data,
  })
}

export function getTravelDateRangeInfoByTourNo(query) {
  return request({
    url: '/TravelSettings/getTravelDateRangeInfoByTourNo',
    method: 'get',
    params: query,
  })
}

export function getCurrenciesByCountries(data) {
  return request({
    url: '/TravelSettings/getCurrenciesByCountries',
    method: 'post',
    data,
  })
}

export function deleteTravel(data) {
  return request({
    url: '/TravelSettings/deleteTravel',
    method: 'post',
    data,
  })
}

export function getAppVersion(query) {
  return request({
    url: '/TravelSettings/getAppVersion',
    method: 'get',
    params: query,
  })
}

export function getAppTypeList(query) {
  return request({
    url: '/TravelSettings/getAppTypeList',
    method: 'get',
    params: query,
  })
}

export function setAppVersion(data) {
  return request({
    url: '/TravelSettings/setAppVersion',
    method: 'post',
    data,
  })
}

export function duplicateTravel(data) {
  return request({
    url: '/TravelSettings/duplicateTravel',
    method: 'post',
    data,
  })
}

export function getTravelPositionRecord(query) {
  return request({
    url: '/TravelSettings/getTravelPositionRecord',
    method: 'get',
    params: query,
  })
}

export function getAgencyDashboard(query) {
  return request({
    url: '/TravelSettings/getAgencyDashboard',
    method: 'get',
    params: query,
  })
}

export function getCurrentNetworkCardPostFee(query) {
  return request({
    url: '/TravelSettings/getCurrentNetworkCardPostFee',
    method: 'get',
    params: query,
  })
}

export function getSettingModifyRecord(query) {
  return request({
    url: '/TravelSettings/getSettingModifyRecord',
    method: 'get',
    params: query,
  })
}

export function gePositionByCountries(data) {
  return request({
    url: '/TravelSettings/gePositionByCountries',
    method: 'post',
    data,
  })
}

export function getTravelLeaderUserID(query) {
  return request({
    url: '/TravelSettings/getTravelLeaderUserID',
    method: 'get',
    params: query,
  })
}

export function getTravelKnowledge(data) {
  return request({
    url: '/TravelSettings/getTravelKnowledge',
    method: 'post',
    data,
  })
}

export function getTravelKnowledgeAll(data) {
  return request({
    url: '/TravelSettings/getTravelKnowledgeAll',
    method: 'post',
    data,
  })
}

export function getTravelKnowledgeByID(id) {
  return request({
    url: '/TravelSettings/getTravelKnowledge/' + id,
    method: 'get',
  })
}

export function deleteTravelKnowledge(data) {
  return request({
    url: '/TravelSettings/deleteTravelKnowledge',
    method: 'post',
    data,
  })
}

export function saveTravelKnowledge(data) {
  return request({
    url: '/TravelSettings/saveTravelKnowledge',
    method: 'post',
    data,
  })
}

export function getTravelStatus() {
  return request({
    url: '/TravelSettings/getTravelStatus',
    method: 'get',
  })
}

export function getSatisfactionAnalysis(query) {
  return request({
    url: '/TravelSettings/getSatisfactionAnalysis',
    method: 'get',
    params: query,
  })
}

export function getQuestionnaireTopicGroupOptions(query) {
  return request({
    url: '/TravelSettings/getQuestionnaireTopicGroupOptions',
    method: 'get',
    params: query,
  })
}

// 上傳共享相簿照片
export function savePublicAlbum(data) {
  return request({
    url: '/TravelSettings/savePublicAlbum',
    method: 'post',
    data,
  })
}

// 刪除共享相簿照片
export function deletePublicAlbumAnPhoto(data) {
  return request({
    url: '/TravelSettings/deletePublicAlbumAnPhoto',
    method: 'post',
    data,
  })
}

// 取得共享相簿群組
export function getPhotoToPublicAlbumGroupTag(data) {
  return request({
    url: '/TravelSettings/getPhotoToPublicAlbumGroupTag',
    method: 'post',
    data,
  })
}

// 新增共享相簿群組
export function savePhotoToPublicAlbumGroupTag(data) {
  return request({
    url: '/TravelSettings/savePhotoToPublicAlbumGroupTag',
    method: 'post',
    data,
  })
}

// 刪除共享相簿群組
export function deletePhotoToPublicAlbumGroupTag(data) {
  return request({
    url: '/TravelSettings/deletePhotoToPublicAlbumGroupTag',
    method: 'post',
    data,
  })
}

// 取得分房表
export function getTravelersRoomHistory(travelID) {
  return request({
    url: '/TravelSettings/getTravelersRoomHistory',
    method: 'post',
    data: { travelID: travelID },
  })
}

// 設定分房表
export function setTravelersRoomHistory(data) {
  return request({
    url: '/TravelSettings/setTravelersRoomHistory',
    method: 'post',
    data,
  })
}

// 取得旅行團清單
export function getTravelNoFilter(agencyCode) {
  return request({
    url: '/TravelSettings/getTravelNoFilter',
    method: 'get',
    params: { agencyCode: agencyCode },
  })
}

// 複製多個旅行團
export function duplicateTravelList(data) {
  return request({
    url: '/TravelSettings/duplicateTravelList',
    method: 'post',
    data: data,
  })
}

// 取得不滿意意見調查表列表
export function getTravelsOpinionNoSatisfied(data) {
  return request({
    url: '/TravelSettings/getTravelsOpinionNoSatisfied',
    method: 'get',
    params: data,
  })
}

// 取得領隊登入紀錄
export function getLeaderLoginRecord(data) {
  return request({
    url: '/TravelSettings/getLeaderLoginRecord',
    method: 'get',
    params: data,
  })
}

// 智能分析旅程資訊
export function travelInfoAnalytics(data) {
  return request({
    url: '/TravelSettings/travelInfoAnalytics',
    method: 'post',
    data: data,
  })
}

export function refreshItinerary(data) {
  return request({
    url: '/TravelSettings/refreshItinerary',
    method: 'post',
    data: data,
  })
}

// 取得領隊登入紀錄
export function getSeminarMovieEvent(data) {
  return request({
    url: '/TravelSettings/getSeminarMovieEvent',
    method: 'get',
    params: data,
  })
}

export function getLoginDate(data) {
  return request({
    url: '/TravelSettings/getLoginDate',
    method: 'get',
    params: data,
  })
}

export function saveLoginDate(data) {
  return request({
    url: '/TravelSettings/saveLoginDate',
    method: 'post',
    data: data,
  })
}

export function getTravelBulletinBoard(data) {
  return request({
    url: '/TravelSettings/getTravelBulletinBoard',
    method: 'get',
    params: data,
  })
}

export function saveTravelBulletinBoard(data) {
  return request({
    url: '/TravelSettings/saveTravelBulletinBoard',
    method: 'post',
    data: data,
  })
}

export function deleteTravelBulletinBoard(data) {
  return request({
    url: '/TravelSettings/deleteTravelBulletinBoard',
    method: 'post',
    data: data,
  })
}

// 建立報名連結
export function createSignUpUrl(data) {
  return request({
    url: '/TravelSettings/CreateSignUpUrl',
    method: 'post',
    data: data,
  })
}
